import {
    Box,
    Divider,
    Drawer,
    IconButton,
    Typography,
    useTheme
} from "@mui/material";
import { Close, Menu } from "@mui/icons-material";

import * as React from "react";
import { FC, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import LinkRouter from "../LinkRouter";


import { IAppBarItem } from "../../containers/DefaultLayout/Header";
import HeaderDropdownMenu from "../HeaderDropdownMenu";
import { logo } from "../../assets/logos";
import HeaderDroprightMenu from "./projects";
import { TypographyMenuStyle } from "./styled";

interface IProps {
    pages: Array<IAppBarItem>
}

const HeaderMenu: FC<IProps> = ({ pages }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const { palette } = useTheme();

    const [isOpen, setIsOpen] = useState(false);

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent
    ) => {
        if (
            event.type === "keydown" &&
            ((event as React.KeyboardEvent).key === "Tab" ||
                (event as React.KeyboardEvent).key === "Shift")
        ) {
            return;
        }

        setIsOpen(open);
    };

    return (
        <>
            <IconButton
                sx={{
                    display: { xs: "inline-flex", lg: "none" },
                    p: "0px",
                    ml: "19px"
                }}
                disableRipple
                size="small"
                color="inherit"
                onClick={toggleDrawer(true)}
            >
                <Menu />
            </IconButton>
            <Drawer
                anchor="right"
                open={isOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        backgroundColor: `${palette.primary.dark} !important`,
                        height: { xs: "635px" },
                        width: { xs: "100%", md: "390px" }
                    }
                }}
            >
                <Box
                    sx={{
                        width: "inherit",
                        p: "53px 30px 0px 6px",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", ml: "16px", mb: "22px" }}>
                        <LinkRouter underline="none" color="unset" to="/" sx={{ display: "flex", width: "154px", height: "28px" }}>
                            <img
                                loading="lazy"
                                style={{ width: "inherit", height: "inherit" }}
                                src={logo}
                                alt="logo"
                            />
                        </LinkRouter>
                        <IconButton disableRipple size="small" sx={{ width: "24px", height: "24px", border: "1px solid #fff", borderRadius: "0px", p: "0px" }} onClick={toggleDrawer(false)}>
                            <Close fontSize="inherit" />
                        </IconButton>
                    </Box>
                    {pages.map((page, index) => (
                        <React.Fragment key={`header_menu_item_${index}`}>
                            {(index !== 3)
                                ? <LinkRouter underline="none" color="inherit" to={page.path} sx={{ display: "flex", width: "fit-content", mb: "14px" }} >
                                    <TypographyMenuStyle selected={(location.pathname === page.path || location.pathname.startsWith(`${page.path}/`))} onClick={() => { setIsOpen(false); }}>
                                        {page.lable}
                                    </TypographyMenuStyle>
                                </LinkRouter>
                                : <HeaderDroprightMenu item={page} closeMenu={() => { setIsOpen(false); }} />
                            }
                            {/* {(index !== 3)
                                ? <LinkRouter underline="none" color="inherit" to={page.path} sx={{ display: "flex" }}>
                                    <TypographyMenuStyle>
                                        {page.lable}
                                    </TypographyMenuStyle>
                                </LinkRouter>
                                : <HeaderDropdownMenu {...page} />
                            } */}
                        </React.Fragment>
                    ))}
                </Box>
            </Drawer>
        </>
    );
}


export default HeaderMenu